import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectCostPlanService {

  constructor(private apiService: ApiBaseService) { }

  async getAllPlanCostsForProject(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostPlanService/GetAllPlanCostsForProject', payLoad, true, true);
  }

  async importProjectTemplateIntoProjectPlan(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostPlanService/ImportProjectTemplateIntoProjectPlan', payLoad, true, true);
  }

  async addCostToProjectCostPlan(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostPlanService/AddCostToProjectCostPlan', payLoad, true, true);
  }

  async editCostOnProjectCostPlan(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostPlanService/EditCostOnProjectCostPlan', payLoad, true, true);
  }

  async deleteCostsOnProjectCostPlan(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostPlanService/DeleteCostsOnProjectCostPlan', payLoad, true, true);
  }

  async freezeProjectCostBudget(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostPlanService/FreezeProjectCostBudget', payLoad, true, true);
  }

  async unfreezeProjectCostBudget(payLoad: any): Promise<any> {
    return this.apiService.httpRequest('ProjectCostPlanService/UnfreezeProjectCostBudget', payLoad, true, true);
  }

}


